import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    navOpen: false,
    openParent: null,
    activeChild: null,
    message: null,
};

const navbarSlice = createSlice({
    name: "navbar",
    initialState,
    reducers: {
        openNav(state) {
            state.navOpen = true;
        },
        closeNav(state) {
            state.navOpen = false;
        },
        toggleParent(state, action) {
            state.openParent =
                state.openParent === action.payload ? null : action.payload;
        },
        setActiveChild(state, action) {
            state.navOpen = !state.navOpen;
            state.activeChild = action.payload;
        },
        showMessage(state, action) {
            state.message = action.payload;
        },
        clearMessage(state) {
            state.message = null;
        },
    },
});

export const {
    openNav,
    closeNav,
    toggleParent,
    setActiveChild,
    showMessage,
    clearMessage,
} = navbarSlice.actions;

export default navbarSlice.reducer;